var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "category-features row roomy" },
    _vm._l(_vm.categories, function (category) {
      return _c(
        "div",
        {
          key: category.id,
          staticClass: "category-feature-lg column-4 laptop:column-2",
        },
        [
          _c(
            "site-link",
            {
              class: `card ${_vm.color}`,
              style: `--card-margin-bottom: var(--spacing-2xl); --card-header-background: var(--fa-navy); --card-link-hover-border-color: var(--fa-${_vm.color})`,
              attrs: { to: _vm.$category({ name: category.id }) },
              nativeOn: {
                click: function ($event) {
                  return _vm.$posthog.capture(
                    "category_landing:suggested_category_link_click",
                    {
                      category: _vm.currentCategory,
                      suggested_category: category.label,
                    }
                  )
                },
              },
            },
            [
              _c("div", { staticClass: "header" }, [
                _c("i", {
                  class: `fas fa-${category.icon} fa-fw fa-3x padding-y-3xs`,
                  style: `color: var(--fa-${_vm.color});`,
                }),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "section" }, [
                _c("p", { staticClass: "text-capitalize text-truncate" }, [
                  _vm._v(_vm._s(category.label) + " icons"),
                ]),
              ]),
            ]
          ),
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }